import React, { useMemo, useState } from "react";
import { PrincipalFormData, PrincipalFormErrors } from "../types";
import { MultiSelectDropdown } from "../../../Dashboard/filters/MultiSelectDropdown";

interface DistributorOption {
  distributorId: number;
  name: string;
}

interface SelfDistributorFormProps {
  formData: PrincipalFormData;
  formErrors: PrincipalFormErrors;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  onDistributorChange: (distributorId: string) => void;
  distributors: DistributorOption[];
  loading?: boolean;
}

const SelfDistributorForm: React.FC<SelfDistributorFormProps> = ({
  formData,
  formErrors,
  onChange,
  onDistributorChange,
  distributors,
  loading = false,
}) => {
  const [isDistributorDropdownOpen, setIsDistributorDropdownOpen] = useState(false);

  const distributorOptions = useMemo(() => {
    return distributors.map((distributor) => ({
      value: distributor.distributorId,
      label: distributor.name,
    }));
  }, [distributors]);

  const selectedDistributor = formData.distributorId ? [Number(formData.distributorId)] : [];

  return (
    <div className="bg-white rounded-xl p-6 flex flex-col justify-start min-h-[120px] transition-shadow duration-200 transition-colors border-[1px] border-cardborder">
      <h2 className="text-lg font-semibold mb-4">Self Distributor</h2>

      <div className="space-y-4">
        <label className="inline-flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            name="addSelfDistributor"
            checked={formData.addSelfDistributor}
            onChange={onChange}
            className="h-4 w-4 text-brand border-gray-300 rounded focus:ring-brand"
          />
          <span className="text-sm text-gray-700">
            Do you want to add self distributor for this principal?
          </span>
        </label>

        {formData.addSelfDistributor && (
          <div className="rounded-lg border border-gray-200 bg-gray-50/70 p-4 space-y-3">
            <div id="distributorId">
              <MultiSelectDropdown<number>
                label="Select Distributor"
                allLabel={loading ? "Loading distributors..." : "Select distributor"}
                selected={selectedDistributor}
                options={distributorOptions}
                open={isDistributorDropdownOpen}
                setOpen={setIsDistributorDropdownOpen}
                onChange={(selected) => {
                  if (selected.length === 0) {
                    onDistributorChange("");
                    return;
                  }
                  onDistributorChange(String(selected[selected.length - 1]));
                }}
              />
            </div>
            {!loading && (
              <p className="text-xs text-gray-500">
                Search is available inside the dropdown list
              </p>
            )}
            {formErrors.distributorId && (
              <div className="text-red-500 text-sm mt-1">{formErrors.distributorId}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelfDistributorForm;
